<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-12-12 13:45:19
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-11-25 14:14:57
 * @FilePath: /wemeet-admin-new/src/views/enterPriseConfig/enterpriseChannelEdit.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <div>
    <vab-query-form style="padding-top: 20px">
      <vab-query-form-right-panel :span="24">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item label="推荐人姓名">
            <el-input v-model="queryForm.enterpriseName" clearable placeholder="请输入推荐人姓名" @clear="queryData" />
          </el-form-item>
          <el-form-item label="手机号码">
            <el-input v-model="queryForm.enterpriseName" clearable placeholder="请输入手机号码" @clear="queryData" />
          </el-form-item>

          <el-form-item label="报名时间">
            <el-date-picker
              v-model="filterTime"
              end-placeholder="结束时间"
              start-placeholder="开始时间"
              type="datetimerange"
              @change="filterTimeChange"
            />
          </el-form-item>
          <el-form-item label="审核状态">
            <el-select v-model="queryForm.status" placeholder="请选择状态">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button :icon="Search" type="primary" @click="queryData">查询</el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" border :data="list" :table-layout="'auto'">
      <el-table-column label="序号" type="index" width="50" />
      <el-table-column label="推荐人姓名" prop="channelName" />
      <el-table-column label="手机号码" prop="viewCount" />
      <el-table-column label="机构" prop="totalEnterpriseNum" />
      <el-table-column label="职位" prop="baseMemberNum" />
      <el-table-column label="报名时间" prop="vipMemberNum" />
      <el-table-column label="审核状态" prop="createTime">
        <template #default="{ row }">
          <span v-if="row.amount">{{ row.amount }}</span>
          <span v-else>0</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="350">
        <template #default="{ row }">
          <el-button plain type="primary" @click="editChannel(row)">审核</el-button>
        </template>
      </el-table-column>
      <template #empty>
        <el-empty class="vab-data-empty" description="暂无数据" />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.pageNumber"
      :layout="layout"
      :page-size="queryForm.pageSize"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />

    <edit ref="editRef" @fetch-data="fetchData" />
  </div>
</template>

<script>
  import {
    defineComponent,
    defineAsyncComponent,
    getCurrentInstance,
    onMounted,
    reactive,
    toRefs,
    onActivated,
  } from 'vue'

  import { Delete, Plus, Search } from '@element-plus/icons'
  import { getChannelList } from '@/api/enterPriseApi'
  import { parseTime } from '@/utils/index'
  import generateWx from './components/generateWx.vue'
  import shareChannelDetail from './components/shareChannelDetail.vue'
  import bindAccount from './components/bindAccount.vue'
  import channelEdit from './components/channelEdit.vue'
  export default defineComponent({
    name: 'EnterPriseChannel',
    components: {
      Edit: defineAsyncComponent(() => import('./components/edit')),
      generateWx,
      shareChannelDetail,
      bindAccount,
      channelEdit,
    },
    setup() {
      const { proxy } = getCurrentInstance()

      const state = reactive({
        queryForm: {
          name: '',
          pageNum: 1,
          pageSize: 20,
          phone: '',
          status: '',
          startTime: '',
          endTime: '',
        },
        filterTime: '',
        total: 0,
        shopList: [],
        listLoading: false,
        list: [],
        layout: 'prev, pager, next',
        editRef: null,
        typeOptions: [],
        generateWxRef: null,
        shareChannelDetailRef: null,
        bindAccountRef: null,
        channelEditRef: null,
        activeName: 'channel',
        options: [
          {
            label: '全部',
            value: '',
          },
          {
            label: '待审核',
            value: 'PENDING_REVIEW',
          },
          {
            label: '审核通过',
            value: 'ACCEPT',
          },
          {
            label: '审核不通过',
            value: 'REFUSE',
          },
        ],
      })

      const handleEdit = (row, type) => {
        row.formStatus = type
        state.editRef.showEdit(row)
      }

      const handleDelete = (row) => {
        if (row.enterpriseCode) {
          proxy.$baseConfirm('你确定要删除当前项吗', null, async () => {
            const { msg } = await delEnterPrise({
              enterpriseCode: row.enterpriseCode,
            })
            proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
            await fetchData()
          })
        }
      }

      const queryData = () => {
        state.queryForm.pageNum = 1
        if (state.filterTime) {
          state.queryForm.startTime = parseTime(state.filterTime[0])
          state.queryForm.endTime = parseTime(state.filterTime[1])
        }
        fetchData()
      }

      const fetchData = async () => {
        state.listLoading = true
        const { data } = await getChannelList(state.queryForm)
        console.log(data, '1123123')
        state.list = data.list
        state.total = data.total
        state.listLoading = false
      }

      const handleSizeChange = (val) => {
        state.queryForm.pageSize = val
        queryData()
      }
      const handleCurrentChange = (val) => {
        state.queryForm.pageNum = val
        queryData()
      }

      onMounted(() => {
        queryData()
      })

      const handleDate = (date) => {
        return parseTime(date)
      }

      const handleQrCode = (row) => {
        let params =
          process.env.NODE_ENV === 'development'
            ? {
                meetingName: 'WeMeet荟客厅',
                pageId: '343',
                exhibitionCode: 'EX1846386251108712448',
              }
            : {
                meetingName: 'WeMeet荟客厅',
                pageId: '733',
                exhibitionCode: 'EX1846741634604150784',
              }
        let qrCodeParams = {
          autoColor: false,
          b: 0,
          env: '',
          g: 0,
          jumpPath: row.code,
          jumpType: '',
          logo: row.logo,
          params: `{"navTitle":"${params.meetingName}", pageId: "${params.pageId}", exhibitionCode: "${params.code}", marketCode: "${row.channelNo}" }`,
          path: 'pages/index/index',
          r: 0,
          scenesType: 'USER_HOLD_EXHIBITION',
          width: 1280,
          miniPath: `subPackage/shops/pages/index-page/index?navTitle=${row.meetingName}&pageId=${row.pageId}&meetingCode=${row.code}&marketCode=${row.channelNo}`,
        }
        state.generateWxRef.handleOpen(row, qrCodeParams)
      }

      const seeDetail = (row) => {
        state.shareChannelDetailRef.handleOpen(row)
      }

      const bindAccount = (row) => {
        state.bindAccountRef.handleOpen(row)
      }

      const editChannel = (row) => {
        state.channelEditRef.showEdit(row)
      }
      return {
        ...toRefs(state),
        handleEdit,
        queryData,
        fetchData,
        handleSizeChange,
        handleCurrentChange,
        handleDelete,
        Delete,
        Search,
        Plus,
        handleDate,
        handleQrCode,
        seeDetail,
        bindAccount,
        editChannel,
      }
    },
  })
</script>
<style lang="scss" scoped></style>
